const getCountText = (phrases: string[], count: number): string => {
  if (phrases.length !== 4) {
    throw Error('phrases - length of array must be 4');
  }

  if (count === 1) {
    return phrases[0];
  } else if (
    ['11', '12', '13', '14'].some((number) => count.toString().endsWith(number))
  ) {
    return phrases[3];
  } else if (
    ['2', '3', '4'].some((number) => count.toString().endsWith(number))
  ) {
    return phrases[1];
  } else if (count.toString().endsWith('1')) {
    return phrases[2];
  } else {
    return phrases[3];
  }
};

export default getCountText;
